import { ReactNode } from 'react';
import './styles.scss';

interface ContainerProps {
  children: ReactNode;
}

function Container({ children }: ContainerProps) {
  return <section className="Container">{children}</section>;
}

export default Container;
